import { Component, Input, OnChanges } from '@angular/core';
import { DateHelper } from '../../../helpers/date.helper';
import { ShiftHelper } from '../../../helpers/shift.helper';

@Component({
  standalone: false,
  selector: 'app-production-plan-header',
  templateUrl: './production-plan-header.component.html',
})

export class ProductionPlanHeaderComponent implements OnChanges {
  @Input() day: any;

  constructor(public dateHelper: DateHelper,
              public shiftHelper: ShiftHelper) {
  }

  ngOnChanges(): void {
    this.day
  }

  trackByFn(index: number): number {
    return index;
  }
}
